import React from 'react';
import DynamicReportList from '../../modules/dynamicreports/DynamicReport';

const DynamicReportPage = () => {
    return (
        <div className="container-fluid">
            <DynamicReportList />
        </div>
    );
};

export default DynamicReportPage;